import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IState {
	isShowLoader: boolean;

}
const initialState: IState = {
	isShowLoader: false,
};

export const apiSlice = createSlice({
	name: "apiSlice",
	initialState,
	reducers: {
		isShowLoader: (state: any, action: PayloadAction<boolean>) => {
			state.isShowLoader = action.payload;
		},
		
	},
});

// Action creators are generated for each case reducer function
export const { isShowLoader } = apiSlice.actions;

export default apiSlice.reducer;
